<template>
  <div>
    <v-autocomplete
      v-model="tags"
      :items="tagOptions"
      item-text="label"
      item-value="id"
      :menu-props="{ maxHeight: '400' }"
      :clearable="true"
      :chips="true"
      :small-chips="true"
      :hide-details="true"
      :label="label"
      deletable-chips
      multiple
      :search-input.sync="search"
      @change="search = ''"
    >
    </v-autocomplete>
  </div>
</template>

<script>
import { getTagsConfig } from "@/services/search/tags.service";

const EMITTED_ACTIONS = {
  CHANGE: "change",
};
export default {
  name: "RiskCategoryTag",
  props: {
    selectedTags: {
      type: String,
    },
    reset: {
      type: String,
    },
  },
  data() {
    return {
      search: "",
      label: "Tag Filter",
      tags: [],
      tagsList: [],
    };
  },
  computed: {
    tagOptions() {
      const sortedTags = this.tagsList.slice().sort(function (a, b) {
        return a.label.toLowerCase().localeCompare(b.label.toLowerCase());
      });
      return sortedTags;
    },
  },
  async mounted() {
    await this.getTags();
    if (this.selectedTags) {
      this.tags = this.selectedTags.split(",");
    }
  },
  methods: {
    async getTags() {
      this.tagsList = await getTagsConfig();
    },
  },
  watch: {
    selectedTags: {
      handler() {
        this.tags = this.selectedTags.split(",");
      },
      deep: true,
    },
    tags: {
      handler(newVal) {
        let selected = newVal.join(",");
        this.$emit(EMITTED_ACTIONS.CHANGE, {
          selectedTags: selected,
        });
      },
      deep: true,
    },
    reset: {
      handler() {
        this.tags = [];
      },
    },
  },
};
</script>

<style scoped></style>
